import type { VideoRepresentation } from '../types';

export const getVideoPrivacyIsCustom = (video: VideoRepresentation) =>
  video.privacy_settings?.is_custom || false;
